import { createReducerContext } from '../../../../utils/create-reducer-context';
import { CustomPageSearchState, CustomPageSearchReducer, ACTION_TYPES } from './custom-page-search-reducer';

const initialState: CustomPageSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
};

const { Provider: CustomPageSearchProvider, useStateContext: useCustomPageSearchState, useDispatchContext: useCustomPageSearchDispatch } = createReducerContext('CustomPageSearch', CustomPageSearchReducer, initialState);

export { CustomPageSearchProvider, useCustomPageSearchState, useCustomPageSearchDispatch, ACTION_TYPES };
